import { Injectable } from '@angular/core';
import {User} from "./app-models/models";
import {HttpClientService} from "./http-client.service";
import {AppConfigService} from "./app-config.service";
import {Headers} from '@angular/http';

@Injectable()
export class CreateUserService {

  private apiUrl = AppConfigService.settings.apiUrl + 'users/';

  constructor(private http: HttpClientService) {
  }

  getData(): Promise<any> {
    return this.http.get(this.apiUrl + 'getoptions')
      .toPromise()
      .then(response => response.json() as any)
      .catch(this.handleError);
  }

  createUser(data: User): Promise<User> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    return this.http.post(this.apiUrl + 'create', JSON.stringify(data), headers)
      .toPromise()
      .then(response => response.json() as User)
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/create-user.service.ts